export enum LoaderStyles {
    LinkFull = "-link-full",
    LinkGlyph = "-link-glyph",
    LinkGlyphBlue = "-link-glyph-blue",
    LinkGlyphGray = "-link-glyph-gray",
}
